import { useState } from "react";
import { CreateServiceV3 } from "../../../../modules/createV3/CreateService";

const useTagInput = () => {
  // Keep track of the tags array.
  const [selectedTags, setSelectedTags] = useState<any[]>([]);
  const service = new CreateServiceV3();

  const handleAddTag = (templateId: number, tagsAdded: any[]) => {
    service.linkTagsToTemplate(templateId, tagsAdded);
  };

  // Function to remove tag from array
  const handleRemoveTag = (templateId: number, tagId: number[]) =>{
    service.unLinkTagsFromTemplate(templateId, tagId);
  }

  return { handleAddTag, handleRemoveTag, selectedTags,setSelectedTags };
};

export default useTagInput;